import getMessages from "app/api/requests/Chat/getMessages";
import getChatToken from "app/api/getChatToken";
import { MessageLocal } from "app/api/types";
import { DateTime } from "luxon";

export const UPDATE_CHAT_MESSAGES = 'UPDATE_CHAT_MESSAGES';

export const loadClientMessages = (clientId: number) => (dispatch: any): any => {
	const token = getChatToken();
	return getMessages(token, clientId)
		.then(messages => {
			const payload = {
				clientId,
				messages: messages.map<MessageLocal>(x => ({
					...x,
					time: DateTime.fromISO(x.time)
				}))
			}
			dispatch({type: UPDATE_CHAT_MESSAGES, payload: payload});
		});
}
